import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import { Col, Row } from "react-bootstrap";

ChartJS.register(ArcElement, Tooltip, Legend);

export const ContinuumPieChart = ({ data, reportTitle }: any) => {
  const chartData = {
    labels: data.map((item: any) => item.area.toUpperCase()),
    datasets: [
      {
        label: "# Cases",
        data: data.map((item: any) => item.numberCases),
        backgroundColor: ["#ed2f2f", "#DA7E39", "#B2BEB5", "#5A7082", "#5D82A0"],
        borderColor: ["#ed2f2f", "#DA7E39", "#B2BEB5", "#5A7082", "#5D82A0"],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    plugins: {
      title: {
        display: true,
        text: reportTitle,
        color: "#5a7082",
        font: {
          size: 18,
          weight: 500,
        },
      },
      legend: {
        display: true,
        position: "left" as const,
        align: "center" as const,
        labels: {
          boxWidth: 25,
          font: {
            size: 14,
          },
          padding: 15,
        },
      },
    },
  };

  return (
    <div style={{ height: 400, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Pie data={chartData} options={options} style={{ maxHeight: "100%", maxWidth: "100%" }} />
    </div>
  );
};
